import { render, staticRenderFns } from "./majorLawyer.vue?vue&type=template&id=6dd1fb65&scoped=true&"
import script from "./majorLawyer.vue?vue&type=script&lang=js&"
export * from "./majorLawyer.vue?vue&type=script&lang=js&"
import style0 from "./majorLawyer.vue?vue&type=style&index=0&id=6dd1fb65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd1fb65",
  null
  
)

export default component.exports